import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {ProgramDTO} from '../../model/dto/program.dto';
import {Webservice} from './webservice';

@Injectable({
    providedIn: 'root'
})
export class ProgramWebservice extends Webservice {
  protected readonly httpBackend = inject(HttpBackend);
  private readonly httpBypass = new HttpClient(this.httpBackend);

    constructor() {
        super();
        this.entity = 'programs';
    }

    // Liste tous les programmes
    getPrograms(): Observable<ProgramDTO[]> {
        return this.httpBypass.get(`${this.root}/inscription`).pipe(
            map(value => value as ProgramDTO[])
        );
    }

    // Liste des events d'un program
    getProgram(id: number) {
        return this.http.get(`${this.root}/${id}`);
    }
}
